<template>
  <div class="auth-box-w">
    <Logo/>

    <h4
        :style="{
        paddingBottom: '10px',
        borderBottom: `2px solid ${tenantColor}`,
        color: '#475569',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: '20px'
      }">
      Login
    </h4>

    <form @submit.prevent="handleLogin" novalidate>
      <div class="form-group">
        <BaseInput
            v-model="formData.email"
            type="email"
            label="E-mail"
            :required=true
            :inputStyle="{ border: '1px solid rgba(0, 0, 0, 0.3)' }"
            :validation="v$.email"
            :messages="v$.email.required.$invalid ? v$.email.required.$message : v$.email.email.$message">
        </BaseInput>
        <div
            class="pre-icon os-icon os-icon-user-male-circle"
            :style="{ color: tenantColor }">
        </div>
      </div>
      <div class="form-group">
        <BaseInput
            v-model="formData.password"
            type="password"
            label="Password"
            :required=true
            :inputStyle="{ border: '1px solid rgba(0, 0, 0, 0.3)' }"
            :validation="v$.password"
            :messages="v$.password.required.$message">
        </BaseInput>
        <div
            class="pre-icon os-icon os-icon-fingerprint"
            :style="{ color: tenantColor }">
        </div>
      </div>

      <div class="row">
        <router-link
            :style="{ color: tenantColor, marginLeft: '11px' }"
            :to="{ name: 'forgotPassword' }">
          Passwort vergessen?
        </router-link>
      </div>

      <div class="buttons-w d-flex justify-content-center">
        <button
            class="btn"
            :style="{ backgroundColor: tenantColor, color: 'white' }"
            type="submit">
          Einloggen
        </button>
      </div>
    </form>
  </div>
</template>
<script setup>
import authService from '@/api/Auth';
import BaseInput from '@/components/base/BaseInput.vue';
import {ErrorToast} from '@/components/VueToast';
import router from '@/router';
import {emailRule, requiredRule} from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import {computed, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import Logo from "@/components/Logo.vue";
import {useTenantColor} from "@/shared/utils/ThemeUtils";

const tenantKey = process.env.VUE_APP_TENANT_KEY
const { tenantColor } = useTenantColor(tenantKey)

const {t} = useI18n();
const formData = ref({
  email: '',
  password: '',
});

const rules = computed(() => {
  return {
    email: emailRule(t),
    password: requiredRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function handleLogin() {
  try {
    v$.value.$touch();
    if (v$.value.$invalid) {
      return;
    }

    const response = await authService.login({
      username: formData.value.email,
      password: formData.value.password,
    });

    const {token, isDeleted, message} = response?.data;

    if (isDeleted || message) {
      localStorage.clear()
      await ErrorToast({
            response: {
              data: {
                error: {
                  message: message
                }
              }
            }
          }
      )
    }

    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('appVersion', response.headers['app-version']);
      await router.push({name: 'dashboardAdminInfo'});
    }

  } catch (err) {
    formData.value.email = '';
    formData.value.password = '';
    await ErrorToast(err, false, t);
  }
}

</script>

<style scoped>
.custom-border-logic :deep(.form-control) {
  border-color: green; /* Boja u mirovanju */
}

.custom-border-logic :deep(.form-control:focus) {
  border-color: #80bdff; /* Standardna Bootstrap plava za fokus */
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
}
</style>